export var SortByQueryOptions;
(function (SortByQueryOptions) {
    SortByQueryOptions["DateAsc"] = "date_asc";
    SortByQueryOptions["DateDesc"] = "date_desc";
    SortByQueryOptions["NameAsc"] = "title_asc";
    SortByQueryOptions["NameDesc"] = "title_desc";
    SortByQueryOptions["Relevance"] = "relevance";
    SortByQueryOptions["BPMAsc"] = "bpm_asc";
    SortByQueryOptions["BPMDesc"] = "bpm_desc";
})(SortByQueryOptions || (SortByQueryOptions = {}));
//# sourceMappingURL=types.js.map